export default __webpack_public_path__ + "media/images/logo-w250-o50-81a36e08183758c419dd25958c60b5a8.png";